import { render } from "./ui-timeline.vue?vue&type=template&id=1a5a38f9"
import script from "./ui-timeline.vue?vue&type=script&lang=js"
export * from "./ui-timeline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__